import { QUERY_PARAM_SORT, QUERY_PARAM_PAGE } from './filter-keys';

const QUERY_PARAM_DATE_RANGE = 'dateRange';
const QUERY_PARAM_EDOCKETID = 'edocketID';
export default [
    QUERY_PARAM_SORT,
    QUERY_PARAM_PAGE,
    QUERY_PARAM_DATE_RANGE,
    QUERY_PARAM_EDOCKETID
];
